import { createDomainRegistry } from "@fergmar/config/domain-registry";
import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

const registry = createDomainRegistry(cloudinaryUrl);

export const { getDomainEntry } = registry;
